import http from '../http-common'
import { APIBaseFunctions } from '@/components/Utility/APIBase'

export class CommonApi extends APIBaseFunctions {
  static getAll (key: string) {
    return http.get(`/${key}/count`)
  }
}

export default new CommonApi()
